export default function formatBelgianCurrency(price: number) {
  return new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR' }).format(price);
}